import PortfolioItemContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemContext';
import useApi from '@/lib/api/useApi';
import { type Tag } from '@/lib/types';
import { Clear as RemoveIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useContext } from 'react';

type RemoveTagProps = {
  tag: Tag;
};

const RemoveTag = ({ tag }: RemoveTagProps) => {
  const api = useApi();
  const {
    portfolioItemApiEndpoint,
    setPortfolioItem,
    setPortfolioItemSummary,
  } = useContext(PortfolioItemContext);

  const removeTag = async (): Promise<void> => {
    api.delete(`${portfolioItemApiEndpoint}/tags/${tag.id}`);

    setPortfolioItem(portfolioItem => {
      portfolioItem.tags = portfolioItem.tags.filter(({ id }) => id !== tag.id);
    });

    setPortfolioItemSummary(portfolioItemSummary => {
      portfolioItemSummary.tags = portfolioItemSummary.tags.filter(
        ({ id }) => id !== tag.id,
      );
    });
  };

  return (
    <IconButton edge="end" size="small" onClick={removeTag}>
      <RemoveIcon fontSize="small" />
    </IconButton>
  );
};

export default RemoveTag;
